import { useLunaToggle } from "@/search/LunaToggleProvider/LunaToggleProvider";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { AppSwitcherMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/AppSwitcherMenu/AppSwitcherMenu";
import { HomeMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenu";
import { useNavigationBarV2Context } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar.provider";
import {
  getNavigationBarRightContainerCss,
  getTrialButtonsVisibilityCss,
  navigationBarContainerCss,
  navigationBarLeftContainerCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavigationBar.styles";
import { NewselaLogo } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NewselaLogo/NewselaLogo";
import { ResourceMenus } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ResourceMenus";
import { SearchMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu";
import { SkipToContentButton } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SkipToContentButton/SkipToContentButton";
import { SubjectItems } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectItems/SubjectItems";
import { SupportCenter } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenter";
import { UserProfileMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfileMenu";
import TrialModal from "@/components/TrialModal";
import {
  useNavBarItemsVisibilityControl,
  NavBarItemVisibilityProvider,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useNavBarItemsVisibilityControl";
import { SubjectsMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenu/SubjectsMenu";

import AISearchMenuContainer from "@/components/AIComponents/AISearchMenuContainer";
import { TrialButtons } from "./PremiumTrial/TrialButtons/TrialButtons.component";

const NavigationBar = () => {
  const {
    trialModal: { trialModalProps },
  } = useNavigationBarV2Context();
  const {
    navBarRef,
    navBarLeftContainerRef,
    navBarRightContainerRef,
    isInitializing,
    isVisible,
  } = useNavBarItemsVisibilityControl();

  const {
    isAISearchEnabled,
    shouldShowAISearch,
    canSeeAiSmartSearch,
    handleAISearchToggle,
  } = useLunaToggle();

  const { canViewSearch } = useGetUserProperties();

  return (
    <header>
      <nav aria-label="Main" css={navigationBarContainerCss} ref={navBarRef}>
        <NavBarItemVisibilityProvider
          value={{
            isVisible,
          }}
        >
          <ul css={navigationBarLeftContainerCss} ref={navBarLeftContainerRef}>
            <AppSwitcherMenu />
            <NewselaLogo />
            {canViewSearch &&
              (canSeeAiSmartSearch && shouldShowAISearch ? (
                <AISearchMenuContainer
                  onToggle={handleAISearchToggle}
                  isAISearchEnabled={isAISearchEnabled}
                />
              ) : (
                <SearchMenu
                  onToggle={handleAISearchToggle}
                  isAISearchEnabled={isAISearchEnabled}
                />
              ))}
            <SkipToContentButton />
          </ul>

          <ul
            css={getNavigationBarRightContainerCss(isInitializing)}
            ref={navBarRightContainerRef}
          >
            <SubjectItems />
            <SubjectsMenu />
            <ResourceMenus />
            <HomeMenu />
            <TrialButtons
              rootCss={getTrialButtonsVisibilityCss(
                isVisible("trial-buttons-item"),
              )}
            />
            <UserProfileMenu />
            <SupportCenter />
          </ul>
        </NavBarItemVisibilityProvider>
      </nav>

      <TrialModal {...trialModalProps} />
    </header>
  );
};

NavigationBar.displayName = "NavigationBar";
export { NavigationBar };
